import React from "react";
import CheckAssistant from "../CheckAssistant/CheckAssistant";
import "./rtga.scss";

/**
 * RTGA 即時報表頁面
 * 只顯示 CheckAssistant 的 new-content 部分
 */
const RTGA = () => {
  return (
    <div className="rtga-page">
      <CheckAssistant displayMode="new-content-only" />
    </div>
  );
};

export default RTGA;
